/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * Provides mapping of password requirements that have/haven't been met
 * @param value The password to validate
 * @returns True/false for each password validation rule
 */
interface IValidate {
    hasMinChars: boolean;
    hasAnyLetter: boolean;
    hasNumber: boolean;
}

export const validatePassword = (value: string): IValidate => ({
    hasMinChars: !!(value && value.length >= 6),
    hasAnyLetter: !!(value && /[a-zA-Z]/.test(value)),
    hasNumber: !!(value && /\d/.test(value)),
});
